import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.min.css';
import '../../styles/blocks/acf/gallery-masonry.scss';

document.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelector('.gallery-masonry .glightbox')) {
    return;
  }

  GLightbox({
    selector: '.gallery-masonry .glightbox',
    touchNavigation: true,
    loop: true,
    autoplayVideos: false,
    openEffect: 'fade',
    closeEffect: 'fade',
  });
});
